const GREEN = "#1f4d33";
const fit = (text, maxWidth, base) => Math.min(base, (maxWidth / Math.max(String(text).length, 1)) * 1.85);
const netWt = (spec) => (spec.match(/^[\d.]+\s?(mg|ml|IU)/i) || [spec])[0];

export default function VialImage({ product, className = "h-24" }) {
  const purity = product.coa_purity ? `${Math.floor(product.coa_purity)}% Pure` : "HPLC Lab Tested";
  const lot = product.coa_lot || "Batch-matched at dispatch";
  return (
    <svg viewBox="0 0 470 910" className={className} data-testid={`vial-image-${product.id}`}
      aria-label={`${product.name} vial — Axis Bio Lab`} role="img">
      <image href="/vial-base.jpg" width="470" height="910" />
      <g textAnchor="middle" fontFamily="'IBM Plex Sans', system-ui, sans-serif" fill="#0f172a">
        <g transform="translate(112,352)" stroke={GREEN} fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 34 L18 2 L32 34" strokeWidth="4" />
          <path d="M9 24 C13 18, 23 18, 27 24" strokeWidth="2.6" />
          <path d="M12 30 C15 26, 21 26, 24 30" strokeWidth="2.6" />
        </g>
        <text x="258" y="386" fontFamily="Georgia, 'Times New Roman', serif" fontSize="42" fontWeight="700" fill={GREEN}>Axis Bio.</text>
        <text x="235" y="466" fontSize={fit(product.name, 320, 46)} fontWeight="700">{product.name}</text>
        <text x="235" y="512" fontSize="38" fontWeight="800" fill={GREEN}>{netWt(product.specification)}</text>
        {product.alias && (
          <text x="235" y="544" fontSize={fit(product.alias, 310, 19)} fontStyle="italic" fill={GREEN}>{product.alias}</text>
        )}
        <text x="235" y="604" fontSize="27" fontWeight="600" fill={GREEN}>{purity}</text>
        <text x="235" y="646" fontSize="20" fontWeight="500">For Research Use Only</text>
        <text x="235" y="694" fontSize="20" fontWeight="600">{`Net Wt: ${netWt(product.specification)}`}</text>
        <text x="235" y="734" fontSize={fit(`Lot: ${lot}`, 300, 18)} fill="#94a3b8">{`Lot: ${lot}`}</text>
      </g>
    </svg>
  );
}
